import { AuthServiceResource } from './base';

export default AuthServiceResource('api/v1/users{/id}');
